import {useMemo, useState} from 'react';
import {Chart} from 'react-charts';
import {Grid} from "@material-ui/core";
import Title from "../Title";
import SelectOption from "../Inputs/Select/Select";

const tipoToElementType = {
  Line: 'line',
  Bar: 'bar',
  BarHorizontal: 'bar',
  BarHorizontalStacked: 'bar',
  Area: 'area',
  Bubble: 'bubble',
};

export const Grafico = (props) => {
  const pageName = props.name;
  const dadosEstatisticos = props.dados;
  const [tipo, setTipo] = useState("");

  const data = useMemo(() => {
    const calculaAcumulado = (etapaKey, dataKey) => {
      let acumulado = 0;
      const dadosfiltrados = dadosEstatisticos[etapaKey].dados.filter(qtdPorDia => qtdPorDia.data !== null);

      for (let i = 0; i <= dataKey; i++) {
        if (dadosfiltrados[i] !== undefined) {
          acumulado += dadosfiltrados[i].quantidades;
        }
      }
      return acumulado;
    }

    return dadosEstatisticos && dadosEstatisticos.length > 0
      ? dadosEstatisticos.map((etapa, etapaKey) => ({
        label: etapa.nome,
        data: (props.cumulativo ? filtrarData(etapa.dados) : etapa.dados).map((quantidadePorDia, key) => ({
          data: quantidadePorDia.data ? formatarData(quantidadePorDia.data) : 'Data vazia',
          quantidades: quantidadePorDia.quantidades,
          quantidadesAcumuladas: quantidadePorDia.data ?
            key === 0 ?
              quantidadePorDia.quantidades : calculaAcumulado(etapaKey, key)
            : 0
        })),
      }))
      : [];
  }, [dadosEstatisticos, props.cumulativo]);

  function formatarData(data) {
    const dataFormatada = new Date(data);
    const dia = dataFormatada.getDate().toString().padStart(2, '0');
    const mes = (dataFormatada.getMonth() + 1).toString().padStart(2, '0');
    const ano = dataFormatada.getFullYear().toString().slice(-2);
    return `${dia}/${mes}/${ano}`;
  }

  function filtrarData(dados) {
    return dados.filter(quantidadePorDia => quantidadePorDia.data !== null);
  };

  const listagem = [
    {label: "Linhas", value: "Line"},
    {label: "Barras", value: "Bar"},
    {label: "Área", value: "Area"},
    {label: "Bolha", value: "Bubble"},
  ];

  const primaryAxis = useMemo(
    () => ({
      getValue: datum => datum.data,
    }),
    []
  );

  const secondaryAxes = useMemo(
    () => [
      {
        getValue: datum => (props.cumulativo ? datum.quantidadesAcumuladas : datum.quantidades),
        elementType: tipoToElementType[tipo] || 'bar',
      },
    ], [props.cumulativo, tipo]
  );

  return (
    <Grid item style={{width: '100%', height: '25rem'}}>
      <Grid container spacing={4} style={{alignItems: 'end'}}>
        <Grid item>
          <Title>{pageName}</Title>
        </Grid>
        <Grid item sm={3} lg={3}>
          <SelectOption
            label='Tipo'
            value={tipo}
            name='Tipo'
            onChange={(e) => setTipo(e.target.value)}
            options={listagem}
          />
        </Grid>
      </Grid>
      <Chart
        options={{
          data,
          primaryAxis,
          secondaryAxes,
        }}
      />
    </Grid>
  );
};

export default Grafico;
